// ABOUTME: Notification component for export_ready notifications
// ABOUTME: Displays when an export is ready to download with download action
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useTranslation } from "react-i18next";
import Text from "../../../theme/text/Text";
import i18n from "../../../../i18n";

const ExportReadyNotificationsComp = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    const handleDownload = () => {
        if(props.onClick) {
            props.onClick();
        }
        if (props.data?.blobUrl) {
            const a = document.createElement('a');
            a.href = props.data.blobUrl;
            a.download = `export_${props.data.exportId}_${new Date().toISOString().split('T')[0]}.xlsx`;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    };

    return(
        <Box
            onClick={handleDownload}
            sx={{
                cursor:"pointer",
                px:1.5,
                display:"flex",
                gap:2,
                width:1,
                borderRadius:4,
                py:1.5,
                transition:"200ms",
                "&:hover" : {
                    background:colors.grey[100],
                    borderBottomColor:'orange'
                }
            }}
        >
            <Box
                sx={{
                    height:32,
                    width:32,
                    flexShrink:0,
                    display:'flex',
                    alignItems:"center",
                    justifyContent:'center',
                    background:theme.palette.mode === "dark" ? colors.blue[700] : colors.blue[100],
                    color:theme.palette.mode === "dark" ? colors.blue[300] : colors.blue[600],
                    borderRadius:3,
                    overflow:'hidden',
                }}
            >
                <DownloadOutlinedIcon/>
            </Box>
            <Box
                sx={{
                    flex:1,
                    display:'flex',
                    flexDirection:'column'
                }}
            >
                <Text bold>{t(props.type)}</Text>
                <Text>{props.body}</Text>
                {props.data?.expirationDate && (
                    <Text light small sx={{mt:0.5}}>
                        {t('expires')}: {new Date(props.data.expirationDate).toLocaleDateString(i18n.language, {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                        })}
                    </Text>
                )}
            </Box>
        </Box>
    )
}

export default ExportReadyNotificationsComp;
